import * as React from 'react';
import { Link } from 'gatsby';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUserGroup,
  faHouse,
  faRankingStar,
  faBookOpen,
  faNewspaper,
  faUsers,
  faDiagramProject
} from '@fortawesome/free-solid-svg-icons';
import { useLocation } from '@reach/router';
import { Nav } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../../state/Store';
import { ToggleMenu } from '../../../layout/actions/Layout.actions';
import { faChartBar } from '@fortawesome/free-regular-svg-icons';

export const EversoulMenu: React.FC = () => {
  const pathFragments = useLocation()
    .pathname.split('/')
    .filter((p) => p && p.trim().length > 0);
  const activeKey = pathFragments.length < 1 ? 'home' : pathFragments[0];

  const model = useSelector((state: RootState) => ({
    layout: state.layout
  }));

  const dispatch = useDispatch();

  const handleOnClick = () => {
    if (model.layout.isMenuVisible === true) {
      dispatch(ToggleMenu());
    }
  };

  return (
    <Nav className="ms-auto" activeKey={activeKey}>
      <Link to="/eversoul/">
        <Nav.Link as="span" eventKey="home" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faHouse} width="18" /> <span>Home</span>
        </Nav.Link>
      </Link>
      <Link to="/eversoul/characters">
        <Nav.Link as="span" eventKey="characters" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faUserGroup} width="18" />{' '}
          <span>Characters</span>
        </Nav.Link>
      </Link>
      <Link to="/eversoul/tier-list">
        <Nav.Link as="span" eventKey="tier-list" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faRankingStar} width="18" />{' '}
          <span>Tier list</span>
        </Nav.Link>
      </Link>
      <Link to="/eversoul/teams-database">
        <Nav.Link as="span" eventKey="team-database" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faUsers} width="18" />{' '}
          <span>Teams Database</span>
        </Nav.Link>
      </Link>
      <Link to="/eversoul/builds">
        <Nav.Link as="span" eventKey="builds" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faDiagramProject} width="18" />{' '}
          <span>Characters Builds</span>
        </Nav.Link>
      </Link>
      <Link to="/eversoul/stats">
        <Nav.Link as="span" eventKey="stats" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faChartBar} width="18" />{' '}
          <span>Characters Stats</span>
        </Nav.Link>
      </Link>
      <hr />
      <Link to="/eversoul/guides/">
        <Nav.Link as="span" eventKey="guides" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faBookOpen} width="18" /> <span>Guides</span>
        </Nav.Link>
      </Link>
      <hr />
      <a href="https://blog.prydwen.gg/category/eversoul/">
        <Nav.Link as="span" eventKey="blog">
          <FontAwesomeIcon icon={faNewspaper} width="18" /> <span>Blog</span>
        </Nav.Link>
      </a>
    </Nav>
  );
};
